import { render, staticRenderFns } from "./previewTable.vue?vue&type=template&id=98e2303c&scoped=true"
import script from "./previewTable.vue?vue&type=script&lang=js"
export * from "./previewTable.vue?vue&type=script&lang=js"
import style0 from "./previewTable.vue?vue&type=style&index=0&id=98e2303c&prod&lang=less&scoped=true"
import style1 from "./previewTable.vue?vue&type=style&index=1&id=98e2303c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e2303c",
  null
  
)

export default component.exports